import { setLinkAriaCurrent } from '@/core/utils/a11y'
import type { TaxiNavigateInEvent } from '@/types/taxi'
import { ThemeEditorSectionUnloadEvent } from '@/types/shopify'
import AJAXKlaviyoForm from '@/core/ajaxKlaviyoForm'
import { wireNewsletterForm } from '@/core/wireNewsletterForm'

import BaseSection from '@/sections/base'

import NewsletterForm from '@/components/newsletterForm'

export default class FooterSection extends BaseSection {
  static TYPE = 'footer'

  newsletterFormEl: HTMLElement | null
  newsletterForm: NewsletterForm | null
  ajaxForm: AJAXKlaviyoForm | null

  constructor(container: HTMLElement) {
    super(container)

    this.newsletterFormEl = this.qs(NewsletterForm.SELECTOR) ?? null
    this.newsletterForm = null
    this.ajaxForm = null

    if (this.newsletterFormEl) {
      this.newsletterForm = new NewsletterForm(this.newsletterFormEl)
      this.ajaxForm = wireNewsletterForm(this.newsletterFormEl, this.newsletterForm)
    }
  }

  onUnload(e: ThemeEditorSectionUnloadEvent) {
    this.newsletterForm?.destroy()
    this.ajaxForm?.destroy()

    super.onUnload(e)
  }

  onNavigateIn(e: TaxiNavigateInEvent) {
    const currentPath = new URL(e.detail.to.finalUrl).pathname
    const links = this.container.querySelectorAll<HTMLAnchorElement>('a')

    links.forEach(link => setLinkAriaCurrent(link, currentPath))
  }  
}